module.exports = __webpack_public_path__ + "img/tribe_of_noise.0a03b0a2.jpg";